"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../../libs/constants");

var _utils = require("../utils");

var _indicator = _interopRequireDefault(require("./indicator"));
/* eslint-disable no-script-url */


var RIGHT_SIDE = 1;
var LEFT_SIDE = -1;

var Indicators =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Indicators, _Component);

  function Indicators(props) {
    var _this$keyHandlerMap;

    var _this;

    (0, _classCallCheck2["default"])(this, Indicators);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Indicators).call(this, props));
    _this.handleKeyPressed = _this.handleKeyPressed.bind((0, _assertThisInitialized2["default"])(_this));
    _this.registerIndicator = _this.registerIndicator.bind((0, _assertThisInitialized2["default"])(_this));
    _this.keyHandlerMap = (_this$keyHandlerMap = {}, (0, _defineProperty2["default"])(_this$keyHandlerMap, _constants.RIGHT_KEY, function () {
      return _this.selectIndicator(RIGHT_SIDE);
    }), (0, _defineProperty2["default"])(_this$keyHandlerMap, _constants.LEFT_KEY, function () {
      return _this.selectIndicator(LEFT_SIDE);
    }), _this$keyHandlerMap);
    _this.state = {
      indicatorsRefs: []
    };
    return _this;
  }

  (0, _createClass2["default"])(Indicators, [{
    key: "setAsSelectedIndicator",
    value: function setAsSelectedIndicator(tabIndex) {
      var indicatorsRefs = this.state.indicatorsRefs;
      indicatorsRefs[tabIndex].ref.current.click();
      indicatorsRefs[tabIndex].ref.current.focus();
    }
  }, {
    key: "registerIndicator",
    value: function registerIndicator(indicator) {
      var indicatorsRefs = this.state.indicatorsRefs;
      var newRefs = indicatorsRefs.concat([indicator]);
      this.setState({
        indicatorsRefs: newRefs
      });
    }
  }, {
    key: "selectIndicator",
    value: function selectIndicator(side) {
      var selectedItem = this.props.selectedItem;
      var indicatorsRefs = this.state.indicatorsRefs;
      var indicatorIndex = (0, _utils.getItemIndex)(indicatorsRefs, selectedItem);

      if (indicatorIndex === indicatorsRefs.length - 1 && side === RIGHT_SIDE) {
        this.setAsSelectedIndicator(0);
      } else if (indicatorIndex === 0 && side === LEFT_SIDE) {
        this.setAsSelectedIndicator(indicatorsRefs.length - 1);
      } else {
        this.setAsSelectedIndicator(indicatorIndex + side);
      }
    }
  }, {
    key: "handleKeyPressed",
    value: function handleKeyPressed(event) {
      if (this.keyHandlerMap[event.keyCode]) {
        return this.keyHandlerMap[event.keyCode]();
      }

      return null;
    }
  }, {
    key: "isSelected",
    value: function isSelected(id) {
      var selectedItem = this.props.selectedItem;
      return selectedItem === id;
    }
  }, {
    key: "renderIndicators",
    value: function renderIndicators() {
      var _this2 = this;

      var _this$props = this.props,
          carouselChildren = _this$props.carouselChildren,
          onSelect = _this$props.onSelect,
          selectedItem = _this$props.selectedItem;
      return carouselChildren.map(function (child) {
        return _react["default"].createElement(_indicator["default"], (0, _extends2["default"])({}, child, {
          onSelect: onSelect,
          selectedItem: selectedItem,
          onCreate: _this2.registerIndicator,
          key: child.indicatorID
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("ul", {
        className: "rainbow-carousel_indicators",
        role: "tablist",
        onKeyDown: this.handleKeyPressed
      }, this.renderIndicators());
    }
  }]);
  return Indicators;
}(_react.Component);

exports["default"] = Indicators;
Indicators.propTypes = {
  carouselChildren: _propTypes["default"].array,
  onSelect: _propTypes["default"].func,
  selectedItem: _propTypes["default"].string
};
Indicators.defaultProps = {
  carouselChildren: [],
  onSelect: function onSelect() {},
  selectedItem: undefined
};